import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    heading = "heading",
    subHeading = "subHeading",
    videoUrl = "videoUrl",
    videoCaption = "videoCaption",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.heading]: string;
        [fields.subHeading]: string;
        [fields.videoUrl]: string;
        [fields.videoCaption]: string;
    };
}

export interface SectionTemplateVideoStyles {
    cardWrapper?: InjectableCss;
    videoHeadingWrapper?: InjectableCss;
    videoHeading?: InjectableCss;
    videoSubHeading?: InjectableCss;
    videoCaption?: InjectableCss;
    dashedSeperator?: InjectableCss;
}

export const sectionTemplateVideoStyles: SectionTemplateVideoStyles = {
    cardWrapper: {
        css: css`
            margin: 0 50px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        margin: 0;
                    `,
                    null,
                ]);
            }}
            iframe {
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            height: 193px;
                        `,
                        css`
                            height: 193px;
                        `,
                        css`
                            height: 193px;
                        `,
                        null,
                    ]);
                }}
            }
        `,
    },
    videoHeadingWrapper: {
        css: css`
            text-align: center;
            margin: 0 20px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        margin: 0;
                    `,
                    null,
                ]);
            }}
        `,
    },
    videoHeading: {
        css: css`
            margin-bottom: 32px !important;
        `,
    },
    videoSubHeading: {
        css: css`
            margin-bottom: 64px !important;
            line-height: 24px;
            color: ${getProp("theme.typography.p.color")};
        `,
    },
    videoCaption: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: 20px;
            color: ${getProp("theme.typography.p.color")};
        `,
    },
    dashedSeperator: {
        css: css`
            display: flex;
            justify-content: center;
            margin: 100px auto !important;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        margin: 56px auto !important;
                    `,
                    null,
                ]);
            }}
        `,
    },
};

const styles = sectionTemplateVideoStyles;
export const SectionTemplateVideo: FC<OwnProps> = ({ fields }) => {
    return (
        <StyledWrapper className="video-wrapper" {...styles.cardWrapper}>
            <StyledWrapper {...styles.videoHeadingWrapper}>
                <Typography variant="h2" {...styles.videoHeading}>
                    {translate("{0}", fields.heading)}
                </Typography>
                <Typography variant="p" {...styles.videoSubHeading}>
                    {translate("{0}", fields.subHeading)}
                </Typography>
            </StyledWrapper>
            <iframe width="100%" height="570px" src={fields.videoUrl} frameBorder="0"></iframe>
            <Typography {...styles.videoCaption}>{translate("{0}", fields.videoCaption)}</Typography>
            <StyledWrapper {...styles.dashedSeperator}>
                <LazyImage src="/userFiles/images/HR.svg" altText="HR" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const sectionTemplateVideo: WidgetModule = {
    component: SectionTemplateVideo,
    definition: {
        group: "Basic",
        icon: "image-landscape",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.heading,
                editorTemplate: "TextField",
                displayName: "Heading",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.subHeading,
                editorTemplate: "TextField",
                displayName: "Sub heading",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.videoUrl,
                editorTemplate: "TextField",
                displayName: "Video Link",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.videoCaption,
                editorTemplate: "TextField",
                displayName: "Video Caption",
                defaultValue: "",
            },
        ],
    },
};

export default sectionTemplateVideo;
